import React from "react";
import ReactApexChart from "react-apexcharts";
import { getColors } from "../Hooks/getColors";

const PieChartApexTotal = ({ dataColors, series, labels, totalLabel }) => {
  // Create a processed series and colors array
  const processedSeries = [...series];
  const processedColors = [...dataColors];
  
  // Calculate total of all values
  const totalValue = series.reduce((sum, value) => sum + value, 0);
  
  // If total is zero, show a full gray circle
  if (totalValue === 0) {
    // Reset to a single item array to show a full circle
    processedSeries.length = 1;
    processedSeries[0] = 1;
    processedColors.length = 1;
    processedColors[0] = "#E9EBEC"; // Light gray for zero total
  } else {
    // Process each value normally
    series.forEach((value, index) => {
      if (value < 0) {
        // For negative values, keep original color but use absolute value
        processedSeries[index] = Math.abs(value);
      } else if (value === 0) {
        // For zero values, make transparent
        processedColors[index] = "transparent";
      }
    });
  }

  const options = {
    labels: labels,
    chart: {
      type: "donut",
      height: 314,
    },
    plotOptions: {
      pie: {
        size: 100,
        offsetX: 0,
        offsetY: 0,
        donut: {
          size: "70%",
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: "16px",
              offsetY: -5,
            },
            value: {
              show: true,
              fontSize: "16px",
              color: "#1B223C",
              fontWeight: 500,
              offsetY: 5,
              formatter: function (val) {
                // Find the original value from series by matching with the processed values
                let originalValue = val;
                for (let i = 0; i < processedSeries.length; i++) {
                  if (Math.abs(processedSeries[i]) === Math.abs(parseFloat(val))) {
                    originalValue = series[i];
                    break;
                  }
                }
                // Add a minus sign for negative values
                const sign = originalValue < 0 ? "-" : "";
                return sign + "₹" + Math.abs(parseFloat(originalValue)).toLocaleString("en-IN");
              },
            },
            total: {
              show: true,
              fontSize: "14px",
              label: totalLabel?.label || "Total",
              color: "#1B223C",
              fontWeight: 400,
              formatter: function (w) {
                // Use original series for calculating the total
                const total = series.reduce((a, b) => a + b, 0);
                if (total === 0) {
                  return "₹0";
                }
                const sign = total < 0 ? "-" : "";
                return sign + "₹" + Math.abs(total).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                  });
              },
            },
          },
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return "₹" + parseFloat(value).toLocaleString("en-IN") + "";
        },
      },
    },
    stroke: {
      lineCap: "round",
      width: 2,
    },
    colors: processedColors,
    tooltip: {
      enabled: true,
      y: {
        formatter: function(value, { seriesIndex }) {
          // Show the original value in tooltips
          return "₹" + series[seriesIndex].toLocaleString("en-IN");
        }
      }
    }
  };

  return (
    <React.Fragment>
      <ReactApexChart
        dir="ltr"
        options={options}
        series={processedSeries}
        type="donut"
        height="220"
        className="apex-charts"
      />
    </React.Fragment>
  );
};

export default PieChartApexTotal;